import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const northdaleConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Northdale Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Northdale, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_northdale',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Northdale',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Northdale Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide expert tree care to the 
     residential neighborhoods and golf course communities of <strong>Northdale</strong>. 
     This established Northwest Tampa community has mature trees throughout its 
     subdivisions that need consistent professional management. Fast Florida growth, 
     storm pressure, and aging root systems all contribute to tree hazards that 
     require experienced, knowledgeable handling.`,

    `We specialize in <strong>dangerous tree removal and precision trimming</strong>
     large limbs overhanging homes and fairways, storm compromised trunks, trees 
     with root instability near structures and pavement, and canopy reduction that 
     keeps your property safe while preserving your landscape's appeal. We assess 
     every job thoroughly and execute with care.`,

    `<strong>Sam's Tree Service</strong> provides trusted, affordable tree care 
     throughout <strong>Northdale</strong> and the surrounding 
     <strong>Northwest Hillsborough</strong> area giving your property 
     the professional attention it needs all year long.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Northdale, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Northdale = () => <LocationPage config={northdaleConfig} />;
export default Services_Northdale;
